var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_30242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0962 9.2043C20.9409 9.3258 18.1998 10.8837 18.1998 14.3478C18.1998 18.3546 21.6878 19.7721 21.7921 19.8072C21.7761 19.8936 21.238 21.7485 19.9532 23.6385C18.8075 25.3017 17.6109 26.9622 15.7907 26.9622C13.9704 26.9622 13.502 25.8957 11.4007 25.8957C9.35288 25.8957 8.62478 26.9973 6.95978 26.9973C5.29479 26.9973 4.13304 25.4583 2.7973 23.5683C1.25008 21.3489 0 17.901 0 14.6286C0 9.3798 3.38353 6.5961 6.71351 6.5961C8.4829 6.5961 9.95784 7.7679 11.0687 7.7679C12.1261 7.7679 13.775 6.5259 15.788 6.5259C16.5509 6.5259 19.292 6.5961 21.0962 9.2043ZM14.8324 4.3038C15.6649 3.3075 16.2538 1.9251 16.2538 0.5427C16.2538 0.351 16.2377 0.1566 16.2029 0C14.8484 0.0513 13.237 0.9099 12.2653 2.0466C11.5024 2.9214 10.7903 4.3038 10.7903 5.7051C10.7903 5.9157 10.8251 6.1263 10.8412 6.1938C10.9269 6.21 11.0661 6.2289 11.2052 6.2289C12.4205 6.2289 13.949 5.4081 14.8324 4.3038Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_30242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7895,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios-icon.7473abdf1951601acba76982a2bea369.svg";
export { ForwardRef as ReactComponent };